export const search = api => ({
  omni(query, success, fail) {
    const params = new URLSearchParams(query);
    api.authenticatedRequest('GET', `/search/omni?${params.toString()}`, null, success, fail);
  },
  omniMentions(term, success, fail) {
    api.authenticatedRequest('GET', `/search/omni/mentions?query=${term}`, null, success, fail);
  },
  admins(term, success, fail) {
    api.authenticatedRequest('GET', `/search/admins?query=${term}`, null, success, fail);
  },
  challengeOwner(challengeId, term, success, fail) {
    api.authenticatedRequest('GET', `/search/challenges/${challengeId}/owner?query=${term}`, null, success, fail);
  },
  challengeAssessors(challengeId, term, success, fail) {
    api.authenticatedRequest('GET', `/search/challenges/${challengeId}/assessors?query=${term}`, null, success, fail);
  },
  ideaCollaborators(id, term, success, fail) {
    api.authenticatedRequest('GET', `/search/ideas/${id}/collaborators/new?query=${term}`, null, success, fail);
  },
  mentionUsers(id, term, success, fail) {
    api.authenticatedRequest('GET', `/search/ideas/${id}/mentions/new?query=${term}`, null, success, fail);
  },
  groupMembers(id, params, success, fail) {
    api.authenticatedRequest('GET', `/search/groups/${id}/members/new?query=${params.term}${params.excludeMembers ? `&excludeMembers=${params.excludeMembers}` : ''}`, null, success, fail);
  },
  messageRecipient(term, success, fail) {
    api.authenticatedRequest('GET', `/search/messages/recipient?query=${term}`, null, success, fail);
  },
  organisationsForRegister(term, success, fail) {
    api.unauthenticatedRequest('GET', `/search/organisations/register?query=${term}`, null, success, fail);
  },
  getRecentSearches(success, fail) {
    api.authenticatedRequest('GET', '/search/omni/recent', null, success, fail);
  },
  recentSearch(searchData, success, fail) {
    api.authenticatedRequest('POST', '/search/omni/recent', searchData, success, fail);
  },
  resolve(pairs, success, fail) {
    api.maybeAuthenticatedRequest('GET', `/search/resolve?${pairs.map(({ type, id }) => `${type}=${id}`).join('&')}`, null, success, fail);
  },
  innovationIntelligenceListSharing(term, exclude, success, fail) {
    api.authenticatedRequest('GET', `/search/innovationintelligence/lists/sharing?query=${term}&exclude=${exclude}`, null, success, fail);
  },
});
